import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

interface Props {
  expirationDate: string
  exploreUrl: string
  tierName: string
}

const CancelConfirmation = ({ expirationDate, exploreUrl, tierName }: Props) => {
  logIFTTTNextAction("page_viewed", {
    object_type: "cancel_plan_confirmed",
    location_type: "cancel_plan_confirmed"
  })

  return (
    <div>
      <h1 className="mt4 mb4 mb2--phone mb2--small-phone">Plan cancelled</h1>

      <p>Your IFTTT {tierName} subscription will end on {expirationDate}.<br/>At that time your benefits will end and your card will not be charged.</p>

      <div className="cancellation-actions mt16 mt20--phone mt20--small-phone">
        <a className="button-primary" href={exploreUrl}>Return to home</a>
      </div>
    </div>
  )
}

export default CancelConfirmation
